<template>
  <Tableau :url="url" :options="options" ref="tableau"></Tableau>
</template>

<script>
export default {
  data() {
    return {
      url: "https://tableau.cld.capspire.com/views/NSRDatabricksHC/NSRAnalysis",
      options: {
        width: "100%",
        height: 900
      }
    };
  }
};
</script>
